var map = {
	"./logo_wally.png": 4830,
	"./logo_wally_big.png": 7745,
	"./ocean-waves-1.jpg": 7434,
	"./ocean-waves-2.jpg": 37,
	"./ocean-waves-3.jpg": 2872,
	"./ocean-waves-5.jpg": 5038,
	"./pins/pin_1.png": 5295,
	"./pins/pin_2.png": 180,
	"./screenshots/screenshot-step1-1.jpg": 3935,
	"./screenshots/screenshot-step2-1.jpg": 6264,
	"./screenshots/screenshot-step2-2.jpg": 4663,
	"./screenshots/screenshot-step2-3.jpg": 826,
	"./screenshots/screenshot-step3-1.jpg": 6161,
	"./screenshots/screenshot-step3-2.jpg": 9462,
	"./screenshots/screenshot-step4-1.jpg": 1114,
	"./screenshots/screenshot-step4-2.jpg": 8341,
	"./screenshots/screenshot-step5-1.jpg": 5627,
	"./screenshots/screenshot-step5-2.jpg": 7932,
	"./screenshots/screenshot-step5-3.jpg": 5305,
	"./screenshots/screenshot-step5-4.jpg": 2714,
	"./screenshots/screenshot-step6-1.jpg": 1060
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3907;